$(document).ready(function(){
    $('.bulk-editor').each(function(){
        new BulkEdit($(this));
    });
});

class SetPresence {
    save(value, $table, context, success, failed) {
        let self = this;
        let data = {
            present: (value == "present") ? true : false,
            ids: []
        };

        $table.find('tbody tr').each(function(){
            var $this = $(this);
            if($this.find('td:first-child > input').is(':checked')) {
                data.ids.push($this.data('id'));
            }
        });

        $.ajax({
            method: 'POST',
            url: '/editions/session/' + $table.closest('.session-participants-container').data('session-id') + '/update-presence', //todo add session ID
            data: data
        }).done(function( msg ) {
            if(msg.success) {
                self.updateWasPresentInTable($table, data);
                success(context);
            } else {
                failed(context);
            }
        });
    }

    updateWasPresentInTable($table, data)
    {
        let html = (data.present) ?
            '<i class="fa fa-check text-success"></i> Yes' :
            '<i class="fa fa-times text-danger"></i> No';

        data.ids.forEach(id => {
            $table.find('tr[data-id='+id+'] td.presence-column').html(html);
        });
    }

}

class BulkEdit {

    constructor($editor) {
        this.$el = $editor;
        this.$fields = $editor.find('.bulk-fields');
        this.$table = $editor.next('table');
        this.$checkboxColumns = this.$table.find('.checkbox-column');
        this.$bulkAction = $editor.find('select');
        this.$submit = $editor.find('button');
        this.$open = $editor.find('.bulk-edit');

        this.$spinner = $('<i></i>', {
            'class' : 'fa fa-spinner fa-spin',
            'style' : 'margin-right:10px;'
        });

        this.events();
    }

    events() {
        var self = this;

        this.$submit.on('click', function(e){
            e.preventDefault();
            if($.trim(self.$bulkAction.val()) === '') return;
            if(self.$table.find('input:checked').length == 0) {
                self.animateColumns(self.$checkboxColumns.filter('td'));

                return;
            }

            self.$submit.append(self.$spinner);
            self.save(self.$bulkAction.val(), self.$bulkAction.find('option:selected').data('class'));
        });

        this.$open.on('click', (e) => {
            e.preventDefault();
            if(this.$fields.is(':visible')) return;

            this.$fields.show();

            this.$checkboxColumns.show();
            const $checkboxColumn = this.$checkboxColumns.filter('td');
            this.animateColumns($checkboxColumn);
        });
    }

    animateColumns($checkboxColumn)
    {
        setTimeout(() => {
            $checkboxColumn.addClass('highlight');
            setTimeout(() => {
                $checkboxColumn.removeClass('highlight');
            },200);
        },100);
    }

    save(value, className) {
        let instance =  eval("new " + className + "()");

        instance.save(value, this.$table, this, this.success, this.failed);
    }

    success(self) {
        self.$checkboxColumns.find('input').prop('checked', false);
        self.$checkboxColumns.hide();
        self.$spinner.remove();
        self.$fields.hide();
    }

    failed(self) {
        alert('Er is helaas iets fout gegaan, probeer later opnieuw of neem contact op met Fluffy Media.');
    }
}